import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {MySortButtonStatesEnum} from '../../../../enums/my-sort-button-states.enum';
import {MyProjectsTableRowActionEnum} from '../../../../enums/my-project-table-row-action.enum';
import {ProjectsApprovalListItemModel} from '../../../../models/projects-approval-list-item.model';
import {ProjectTablesBase} from '../../project-tables-base';
import {BrotherDepartmentTypeEnum} from '../../../../enums/brother-department-type.enum';
import {ResponsibleApprovalRoleEnum} from '../../../../enums/responsible-approval-role.enum';

@Component({
    selector: 'app-projects-price-approval-table',
    templateUrl: './projects-price-approval-table.component.html',
    styleUrls: ['./projects-price-approval-table.component.scss']
})
export class ProjectsPriceApprovalTableComponent extends ProjectTablesBase implements OnInit, OnChanges {

    @Input() public projects: ProjectsApprovalListItemModel[];
    @Input() public isProcessedModeUsed = false;  // if the table is used for second tab 'Bearbeitete Projekte / Processed projects'
    @Output() public headerSortBtnClicked = new EventEmitter<{ columnId: string; state: MySortButtonStatesEnum }>();
    @Output() public projectTableRowActionsMenuClicked =
        new EventEmitter<{ projectsListItem: ProjectsApprovalListItemModel, actionId: MyProjectsTableRowActionEnum }>();


    private readyTableColumnsLabels = [
        {label: 'Projektname / Firma', propertyToSort: 'name'},
        {label: 'Geräte', propertyToSort: 'requestedProductsTotalCount'},
        {label: 'Angebots abgabe', propertyToSort: 'quoteClosingDate', defaultState: MySortButtonStatesEnum.DESCENT},
        {label: 'Projekt zeitraum', propertyToSort: 'rolloutStart'},
        {label: 'Account Manager', propertyToSort: 'kam'},
        {label: 'Bearbeitet von', propertyToSort: 'lastUpdateBy'},
        {label: 'Kondition', propertyToSort: 'maxCondition'}
    ];

    private processedTableColumnsLabels = [
        {label: 'Projektname / Firma', propertyToSort: 'name'},
        {label: 'Geräte', propertyToSort: 'requestedProductsTotalCount'},
        {label: 'Angebots abgabe', propertyToSort: 'quoteClosingDate', defaultState: MySortButtonStatesEnum.DESCENT},
        {label: 'Projekt zeitraum', propertyToSort: 'rolloutStart'},
        {label: 'Account Manager', propertyToSort: 'kam'},
        {label: 'Bearbeitet von', propertyToSort: 'lastUpdateBy'},
        {label: 'Kondition', propertyToSort: 'maxCondition'},
        {label: 'Freigabe', propertyToSort: 'priceApprovalStatus'}
    ];

    public tableColumnsLabels = this.readyTableColumnsLabels;

    private activeApprovalRole: BrotherDepartmentTypeEnum;

    constructor( ) {
        super();
    }

    public ngOnInit() {
        this.activeApprovalRole = null;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.isProcessedModeUsed) {
            this.tableColumnsLabels = this.processedTableColumnsLabels;
        } else {
            this.tableColumnsLabels = this.readyTableColumnsLabels;
        }
    };

    public onHeaderSortBtnClicked($event: { columnId: string; state: MySortButtonStatesEnum }) {
        this.headerSortBtnClicked.emit($event);
    }


    public onProjectActionsMenuClicked($event: { projectListItem: ProjectsApprovalListItemModel, actionId: MyProjectsTableRowActionEnum }) {
        this.projectTableRowActionsMenuClicked.emit({
            projectsListItem: $event.projectListItem,
            actionId: $event.actionId
        });
    }

    /**
     * returns true if the current user is SALES_DIRECTOR but the project is not for SALES_DIRECTOR
     * (in this case the sales director can approve these project for example if the SALES_MANAGER is not available,
     * but most of time the director should not process these projects, so the projects should be less visible or somehow visually marked/distinguished  )
     * @param project
     */
    public isNotForCurrentUser(project: ProjectsApprovalListItemModel) : boolean {
        return false
    }

}
